import React, { useState, useEffect, useRef, createContext, useContext, canvasRef} from 'react';
import { CONSTANT } from './constants'; // Import your constants

import { initializeViewerNew } from '../utils/helpers';
export const HologramViewerContext = createContext();
import { GlobalContext } from '../utils/GlobalContext';

export const HologramViewer = ({ children }) => {

    // const [glbFiles,setglbFiles] = useState();
    const [glbUrl, setGlbUrl] = useState('');
    const { category,client_code } = useContext(GlobalContext)
    // Holds the raw ES module from the last successful viewer load, so applyEngraving can
    // reach it without RingBuilderCustomize.jsx needing to thread anything through as a prop.
    const viewerModuleRef = useRef(null);

    const applyEngraving = (patch) => {
        return viewerModuleRef.current?.applyEngraving ? viewerModuleRef.current.applyEngraving(patch) : null;
    };

    const getHologram = async (glbFiles, canvas) => {
        if (!glbFiles || typeof glbFiles !== 'string' || glbFiles.trim() === '') {
            console.error("Invalid GLB file name:", glbFiles);
            return;
        }

        // Check for invalid file paths (undefined, null, etc.)
        if (glbFiles.includes('undefined') || glbFiles.includes('null')) {
            console.error("GLB file path contains invalid value:", glbFiles);
            return;
        }

        let url = '';
        if(category == 'Ring Builder'){
            url = `${glbFiles}`;
        }else{
            url = `${CONSTANT.BASE_URL}uploads/${glbFiles}`;
        }
        await setGlbUrl(url);

        console.log("3D Viewers check details");
        let viewerContainer = document.getElementById('mcanvas');
        if (!viewerContainer) {
            viewerContainer = canvas;
            if (!viewerContainer) {
                console.log("3D viewer container not found.");
                return;
            }
        }
        let comModules = {};
        // Only Family Builder disposes the previous ViewerApp before creating a new one for now,
        // to avoid changing behavior for other builder types (Ring Builder, etc.) that share this code path.
        comModules = await initializeViewerNew(url, category === 'Family Builder');
        viewerModuleRef.current = comModules?.module || null;

        return comModules;
        // Call updateCanvas1 and then trigger your additional function
    };

    return(
        <HologramViewerContext.Provider value={{getHologram, applyEngraving}}>
            <div id="mconfig" style={{display:'none'}}></div>
            {children}
        </HologramViewerContext.Provider>
    )
};